import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import { Card } from 'react-bootstrap';
import { getLoadTripList } from "../../actions/load";
import LoadTripCard from './LoadTripCard';
import { API_DATE_FORMAT, DISPLAY_DATE_FORMAT2 } from '../../constants';

const LoadTripList = props => {
    const { loadTripList, timezone, loadTripWorkWindow,
        analyze: { farmId, egId }, search: { rangeId, custom } } = props;
    const [selectedTripIds, setSelectedTripIds] = useState([]);

    loadTripWorkWindow.getTrip = ({ tripId }) => {
        const findTrips = loadTripList.payload.filter(e => e.trip_id === tripId);
        if (findTrips.length === 0) return;
        return {
            visitId: findTrips[0].visit_id,
            visitDate: moment.utc(findTrips[0].farm_day).format(DISPLAY_DATE_FORMAT2)
        };
    };

    const getLoadTrips = () => {
        let from = null, to = null;
        if (custom.from && custom.to) {
            from = moment.utc(custom.from);
            to = moment.utc(custom.to);
        } else {
            const now = moment.utc().tz(timezone);
            from = now.clone().startOf("day");
            to = now.clone().endOf("day");
        }

        const params = {
            farmId, transporterEGId: egId,
            fromDate: from.format(API_DATE_FORMAT),
            toDate: to.format(API_DATE_FORMAT),
        };
        props.actions.getLoadTripList(params);
    };

    useEffect(() => {
        getLoadTrips();
        return () => loadTripWorkWindow.clearWorkWindows();
    }, [farmId, egId, rangeId]);

    const onClickWorkWindow = (tripId, workWindows) => {
        let list = [...selectedTripIds];
        if (list.indexOf(tripId) >= 0) {
            list.splice(list.indexOf(tripId), 1);
            loadTripWorkWindow.removeWorkWindow(tripId);
        } else {
            list.push(tripId);
            loadTripWorkWindow.getWorkWindow({ tripId, workWindows });
        }
        setSelectedTripIds(list);
    }

    return <Card className="card-load-trip">
        <Card.Header className="card-load-trip-header">
            Load Trips {!loadTripList.isRequesting && loadTripList.payload.length > 0 && <>({loadTripList.payload.length})</>}
        </Card.Header>
        <Card.Body className="card-load-trip-list">
            {loadTripList.isRequesting && <div className="loading">Loading...</div>}
            {!loadTripList.isRequesting && loadTripList.payload.length === 0 && <div className="no-records-found">No load trips found</div>}
            {!loadTripList.isRequesting &&
                loadTripList.payload
                    .map(e => ({ ...e, trip_day: moment.utc(e.farm_day) }))
                    .sort((a, b) => a.trip_day - b.trip_day || (a.visit_id - b.visit_id))
                    .map(e =>
                        <LoadTripCard
                            key={e.trip_id}
                            trip={e}
                            selected={selectedTripIds.indexOf(e.trip_id) >= 0}
                            onClickWorkWindow={() => onClickWorkWindow(e.trip_id, e.work_windows)}
                        />
                    )}
        </Card.Body>
    </Card>;
};

const mapStateToProps = state => ({
    timezone: state.farm.currentFarm.timezone_identifier,
    analyze: {
        farmId: state.analyze.analyzeParams.farmId,
        egId: state.analyze.analyzeParams.egId
    },
    search: {
        rangeId: state.analyze.searchParams.rangeId,
        custom: state.analyze.searchParams.custom
    },
    loadTripList: state.load.loadTripList
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ getLoadTripList }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadTripList);